import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Arvind 1234 Save transaction
import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { RefundDetails, FinanceVP, Transaction, CommentsDetails } from '@accountexecutivemodel/AccountExecutive';
import { environment } from '@environment/environment';
import { SaveTransaction } from '@externalusermodel/Order';
import { GetEnvVarService } from "../../service/get-env-var.service";
// Arvind 1234 Save transaction
import { Options } from '../../../../node_modules/@types/selenium-webdriver/opera';
@Injectable()
export class AccountExecutiveService {

  storedAccessJwtToken = sessionStorage.getItem('token');
  private baseUrl: string;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }
  // Method to get Finance VP Details
  getFinanceVPs() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Refund/FinanceVP`, options)
      .map(response => response as FinanceVP[])
      .catch(handleError);
  }
  // Method to get Refund Details
  getRefundDetails() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Refund`, options)
      .map(response => response as RefundDetails[])
      .catch(handleError);
  }
  // Method to update refund details
  saveRefundDetails(RefundDetailsModel, currentTrancationID): Observable<any> {
debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/SaveRefundDetails/` + currentTrancationID, JSON.stringify(RefundDetailsModel), options)
      .map(response => response as any);
  }
  // Method to get transaction Details
  getTransactionDetails(UserID: any, Period: any, isshowtransChecked: boolean): Observable<any> {
debugger;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Transaction/` + UserID + `/` + Period + `/` + isshowtransChecked,options)
      .map(response => response as Transaction[])
      .catch(handleError);
  }
  getComments(refundDetailsID: any): Observable<any> {
    return this.http.get(this.baseUrl + `/api/GetComments/` + refundDetailsID)
      .map(response => response as CommentsDetails[])
      .catch(handleError);
  }
  saveComments(CommentsModel: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/SaveComments/`, JSON.stringify(CommentsModel), options)
      .map(response => response as any)
      .catch(handleError);
  }
    //To get Refund Calculation
    getRefundCalculation(amount: any,paymentType:any,type: any,invoiceID:any,orderID:any): Observable<any> {
      return this.http.get(this.baseUrl + `/api/RefundCalc/` + amount + `/` +  paymentType + `/` + type + `/` + invoiceID + `/` + orderID)
        .map(response => response as any)
        .catch(handleError);
    }

      // Arvind Method to get transaction Details by date.
  getTransactionDetailsDate(UserID: any, value1: Date, value2: Date, isshowtransChecked: boolean): Observable<any> {
    debugger;
    return this.http.get(this.baseUrl + `/api/SearchTransaction/` + UserID + `/` + isshowtransChecked + `/` + value1 + `/` + value2)
      .map(response => response as Transaction[])
      .catch(handleError);
  }
// Arvind 1234 for save Transaction 
saveTransaction(requestData: SaveTransaction): Observable<any> {
   debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = { headers: headers };
  //let test = JSON.stringify(requestData);
 return this.http.put(this.baseUrl + `/api/order/saveTransaction`, JSON.stringify(requestData), options)
            .map(response => response as any)
            .catch(handleError);
  }

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);
  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/account-executive/Service/account-executive.service.ts